"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOutcomeNameWithoutCustomization = void 0;
const betweb_openapi_axios_1 = require("betweb-openapi-axios");
const i18next_1 = __importDefault(require("i18next"));
const constants_1 = require("../../../constants");
const outcomeHasParams = (probabilityParamTypes, parameterTypes) => parameterTypes.every((parameterType) => probabilityParamTypes.has(parameterType));
const getOutcomeParameterValue = (paramsMap, parameterType) => {
    return paramsMap[parameterType] || '';
};
const getScoreName = (paramsMap, options) => {
    const isHalf = (options === null || options === void 0 ? void 0 : options.isHalf) || false;
    const homeScore = getOutcomeParameterValue(paramsMap, isHalf ? betweb_openapi_axios_1.ParameterType.HalfHomeScore : betweb_openapi_axios_1.ParameterType.HomeScore);
    const awayScore = getOutcomeParameterValue(paramsMap, isHalf ? betweb_openapi_axios_1.ParameterType.HalfAwayScore : betweb_openapi_axios_1.ParameterType.AwayScore);
    if (homeScore === '-1' && awayScore === '-1') {
        return i18next_1.default.t('anyOther') || 'any other';
    }
    return `${homeScore}:${awayScore}`;
};
const getOutcomeParameterPlayer = (paramsMap, players) => {
    const playerId = paramsMap[betweb_openapi_axios_1.ParameterType.PlayerId];
    const player = players[playerId];
    return (player === null || player === void 0 ? void 0 : player.name) || '';
};
const transformParamValue = (value, templateId) => {
    const withPlus = constants_1.TEMPLATES_WITH_PLUS_SIGN.includes(templateId);
    const withParentheses = constants_1.TEMPLATES_WITH_PARENTHESES.includes(templateId);
    let result = value;
    if (withPlus && !value.startsWith('-') && Number(value) !== 0) {
        result = `+${result}`;
    }
    if (withParentheses) {
        result = `(${result})`;
    }
    return result;
};
const addParamValueToOutcomeTypeName = (outcomeTypeName, parameterValue) => {
    if (!outcomeTypeName)
        return parameterValue;
    return `${outcomeTypeName.trim()} ${parameterValue}`;
};
const getOutcomeNameWithoutCustomization = ({ eventProbability, templateId, outcomeTypeName, players, }) => {
    var _a;
    const parameters = (_a = eventProbability === null || eventProbability === void 0 ? void 0 : eventProbability.parameters) !== null && _a !== void 0 ? _a : [];
    if (parameters.length === 0) {
        return outcomeTypeName;
    }
    const paramsMap = parameters.reduce((acc, param) => {
        acc[param.type] = param.value;
        return acc;
    }, {});
    const paramsTypes = new Set(Object.keys(paramsMap));
    switch (true) {
        // Case Score
        case outcomeHasParams(paramsTypes, [
            betweb_openapi_axios_1.ParameterType.HomeScore,
            betweb_openapi_axios_1.ParameterType.AwayScore,
        ]):
            return getScoreName(paramsMap);
        // Case Half Score
        case outcomeHasParams(paramsTypes, [
            betweb_openapi_axios_1.ParameterType.HalfHomeScore,
            betweb_openapi_axios_1.ParameterType.HalfAwayScore,
        ]):
            return getScoreName(paramsMap, { isHalf: true });
        // Case Players
        case outcomeHasParams(paramsTypes, [betweb_openapi_axios_1.ParameterType.PlayerId]):
            return getOutcomeParameterPlayer(paramsMap, players);
        // Case Value
        case outcomeHasParams(paramsTypes, [betweb_openapi_axios_1.ParameterType.Value]):
            return addParamValueToOutcomeTypeName(outcomeTypeName, transformParamValue(getOutcomeParameterValue(paramsMap, betweb_openapi_axios_1.ParameterType.Value), templateId));
        // Case GoalsRange
        case outcomeHasParams(paramsTypes, [betweb_openapi_axios_1.ParameterType.GoalsRange]):
            return addParamValueToOutcomeTypeName(outcomeTypeName, getOutcomeParameterValue(paramsMap, betweb_openapi_axios_1.ParameterType.GoalsRange));
        // Case TimeRange
        case outcomeHasParams(paramsTypes, [betweb_openapi_axios_1.ParameterType.TimeRange]):
            return addParamValueToOutcomeTypeName(outcomeTypeName, getOutcomeParameterValue(paramsMap, betweb_openapi_axios_1.ParameterType.TimeRange));
        // Case PointRange
        case outcomeHasParams(paramsTypes, [betweb_openapi_axios_1.ParameterType.PointRange]):
            return addParamValueToOutcomeTypeName(outcomeTypeName, getOutcomeParameterValue(paramsMap, betweb_openapi_axios_1.ParameterType.PointRange));
        // Case Range
        case outcomeHasParams(paramsTypes, [betweb_openapi_axios_1.ParameterType.Range]):
            return addParamValueToOutcomeTypeName(outcomeTypeName, getOutcomeParameterValue(paramsMap, betweb_openapi_axios_1.ParameterType.Range));
        // Case ExactGoals
        case outcomeHasParams(paramsTypes, [betweb_openapi_axios_1.ParameterType.ExactGoals]):
            return addParamValueToOutcomeTypeName(outcomeTypeName, getOutcomeParameterValue(paramsMap, betweb_openapi_axios_1.ParameterType.ExactGoals));
        // Case Exact
        case outcomeHasParams(paramsTypes, [betweb_openapi_axios_1.ParameterType.Exact]):
            return addParamValueToOutcomeTypeName(outcomeTypeName, getOutcomeParameterValue(paramsMap, betweb_openapi_axios_1.ParameterType.Exact));
        // Case WinningMargin
        case outcomeHasParams(paramsTypes, [betweb_openapi_axios_1.ParameterType.WinningMargin]):
            return addParamValueToOutcomeTypeName(outcomeTypeName, getOutcomeParameterValue(paramsMap, betweb_openapi_axios_1.ParameterType.WinningMargin));
        default: {
            return outcomeTypeName;
        }
    }
};
exports.getOutcomeNameWithoutCustomization = getOutcomeNameWithoutCustomization;
//# sourceMappingURL=getOutcomeNameWithoutCustomization.js.map